// extracted by mini-css-extract-plugin
module.exports = {"carousel-indicators":"b2bClientCarousel_carousel-indicators__1jijh","active":"b2bClientCarousel_active__20D7Z"};